export default "__VITE_ASSET__t_LRS7JT__"